import React from "react";
import Navbar from "./components/navbar";
import CreateAlocentralmovilComponent from "./create/create.component";
import CreateAlocentralmovilProvider from "./create/provider/createAlocentralmovil.provider";
import CreateUsedAlocentralmovilProvider from "./create/used/provider/createUsedAlocentralmovil.provider";
import CreateNewsAlocentralmovilProvider from "./create/news/provider/createNewsAlocentralmovil.provider";

const AlocentralmovilPage = () => {
  return (
    <CreateAlocentralmovilProvider>
      <CreateNewsAlocentralmovilProvider>
        <CreateUsedAlocentralmovilProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#E21F13]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0 pt-20">
              <div className="container mb-auto mt-auto w-full px-4 py-20 lg:px-20">
                <CreateAlocentralmovilComponent />
              </div>
            </section>
          </div>
        </CreateUsedAlocentralmovilProvider>
      </CreateNewsAlocentralmovilProvider>
    </CreateAlocentralmovilProvider>
  );
};

export default AlocentralmovilPage;
